import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Text from 'components/text/text';
import TransitionLink from 'components/transition-link/transition-link';
import messages from './messages';

function DefaultProductInfo(props){
  const { intl, data } = props;
  const sizeLabel = intl.formatMessage(messages[`${data.type}_size_label`]) + ':';

  return (
    <div className="set">
      <div className="set-hd">
        <Text
          type="xl"
          color="Darkest"
          className="mix-txt_capitalize"
          weight="light"
        >
          {data.name}
        </Text>
      </div>

      <div className="set-bd set-bd_detached">
        <Text
          type="sm"
          color="DefaultGray"
          className="mix-txt_uppercase"
        >
          {sizeLabel}
        </Text>

        <Text
          type="sm"
          color="DarkGray"
        >
          {` ${data.size}`}
        </Text>
      </div>

      <div className="set-bd set-bd_detached">
        <Text
          type="md"
          color="DefaultGray"
          dangerouslySetInnerHTML={ {__html: data.description} }
        >
        </Text>
      </div>

      <div className="set-bd set-bd_disengaged">
          <TransitionLink
            animateOnClick
            to={data.url}
            target="_blank"
            className="btn btn_light btn_fixedWidthLg"
          >
            {intl.formatMessage(messages.view_on_specialized_label)}
          </TransitionLink>
      </div>
    </div>
  );
}

const dataShape = PropTypes.shape({
  'description': PropTypes.string,
  'name': PropTypes.string,
  'size': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  'type': PropTypes.string.isRequired,
  'url': PropTypes.string
});

DefaultProductInfo.propTypes = {
  'data': dataShape.isRequired
};

export default injectIntl(DefaultProductInfo);



// WEBPACK FOOTER //
// ./src/client/pages/product-matches/_default-product-info.jsx